import React, { useContext } from "react";
import { Modal, Center, ModalBody, ModalContent, ModalOverlay, Text, VStack, } from "@reverb-ui/react";
import { useHistory } from "react-router";
import { Check } from "@reverb-ui/icons-react";
import { AuthContext } from "@/shared/presentation/context-api/providers/auth";
export var RegistrationDone = function () {
    var history = useHistory();
    var renewToken = useContext(AuthContext).renewToken;
    setTimeout(function () {
        renewToken().then(function () {
            history.push("/home");
        });
    }, 1000);
    return (React.createElement(Modal, { isOpen: true, onClose: function () { return null; }, size: "xs" },
        React.createElement(ModalOverlay, null,
            React.createElement(ModalContent, null,
                React.createElement(ModalBody, null,
                    React.createElement(VStack, { spacing: 4, py: 8 },
                        React.createElement(Center, { justifyContent: "center", alignItems: "center", rounded: 100, h: "40px", w: "40px", bg: "green.500" },
                            React.createElement(Check, { color: "white", size: "lg" })),
                        React.createElement(Text, { fontWeight: "bold" }, "Registration done successfully")))))));
};
